/**
 * Launch query params that PERSIST in the URL across the onboarding flow —
 * re-appended on every navigation by `appendLaunchParamsToHref`.
 *
 * Onboarding otherwise drops query params after the cold-start redirect (the
 * rules engine routes from durable state, not the URL), so only the keys listed
 * here survive. This is a deliberate allowlist rather than "keep every param":
 * persisting arbitrary params risks leaking unintended values into the URL — and
 * is why PII is never round-tripped through the URL (it flows via the draft).
 *
 * The params themselves are captured in `@/modules/clientContext`; this constant
 * is the navigation-side policy for which of them stay in the URL. Add future
 * families here (e.g. `utm_*` attribution) to have them persist too.
 */
export const PERSISTENT_LAUNCH_PARAMS = [
  'vida_client',
  'vida_client_version',
  'branch_name',
] as const;
